// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3m-WB","detailsBorder":"styles_detailsBorder__6OF96"};